import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { SkippedPaymentDialogProps } from './SkippedPaymentDialog.types';

export const openSkippedPaymentModal = (data: SkippedPaymentDialogProps) =>
    openPopupHelper({ popupName: popupNames.SKIPPED_PAYMENT_MODAL, data });
